import { isInternalURL } from '@plone/volto/helpers/Url/Url';

// Função utilitária para garantir compatibilidade
function formatSaveMessage(intl, message) {
  if (intl && typeof intl.formatMessage === 'function') {
    // Caso padrão do React Intl
    return intl.formatMessage(message);
  }
  if (typeof intl === 'function') {
    // Caso venha direto como função
    return intl(message);
  }
  // Fallback
  return message?.defaultMessage || 'Content';
}

export const schemaExtender = (schema, data, intl) => {
  const devices = ['desktop', 'tablet', 'phone'];

  const requiredFields = devices.reduce((acc, device) => {
    if (data?.overwrite && data?.customized?.[`preview_image_${device}`]) {
      return [...acc, `alt_${device}`];
    }

    return acc;
  }, []);

  if (data?.overwrite) {
    requiredFields.push('alt_desktop');
  }

  // Se fonte externa ou sem fonte, precisa ter imagem customizada preenchida
  if (
    (data?.href?.[0] && !isInternalURL(data.href[0]?.['@id'])) ||
    data?.withoutSource
  ) {
    requiredFields.push('preview_image_desktop');
  }

  return {
    ...schema,
    properties: {
      ...schema.properties,
      customized: {
        ...schema.properties.customized,
        schema: {
          ...schema.properties.customized.schema,
          required: requiredFields,
        },
      },
    },
    fieldsets: [
      {
        id: 'content',
        title: formatSaveMessage(intl, {
          id: 'Content',
          defaultMessage: 'Content',
        }),
        fields: [
          ...(data?.withoutSource !== true ? ['href'] : []),
          ...(data?.href?.[0]
            ? [
                'hide_info',
                ...(isInternalURL(data.href[0]?.['@id'])
                  ? ['overwrite_help', 'overwrite']
                  : []),

                ...(data?.overwrite
                  ? []
                  : [
                      'alignment_help',
                      'horizontal_alignment',
                      'vertical_alignment',
                    ]),
              ]
            : [
                ...(data?.overwrite && data?.withoutSource !== true
                  ? ['withoutSource', 'overwrite_help', 'overwrite']
                  : ['withoutSource']),
              ]),
          ...(data?.withoutSource === true ? ['hide_info'] : []),
          ...(data?.overwrite ? ['customized_help', 'customized'] : []),
        ].filter(Boolean),
      },
    ],
    required: [...(data?.withoutSource !== true ? ['href'] : [])],
  };
};
